module.exports = __webpack_public_path__ + "img/Picture1.d4c80d65.png";